export default __webpack_public_path__ + "static/media/partner3.beec329f.jpeg";